import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CampusService } from '@services/campus.service';
import { GroupOfPoliceService } from '@services/groupOfPolicies.service';
import { PolicyService } from '@services/policy.service';
import { CoreModule } from 'app/modules/core.module';
import Swal from 'sweetalert2'
@Component({
  selector: 'app-modal-group-of-policies',
  standalone: true,
  imports: [CoreModule, NgSelectModule],
  providers: [PolicyService, CampusService],
  templateUrl: './modal-group-of-policies.component.html',
  styleUrls: ['./modal-group-of-policies.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalGroupOfPoliciesComponent implements OnInit {
  @Input() group: any
  @Input() permissions: any
  @Output() group_save: EventEmitter<Boolean> = new EventEmitter<Boolean>()
  public GroupForm: FormGroup
  private newGroup = true
  public listPolicies = []
  public listCampus = []
  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })
  private _campusService = inject(CampusService)
  private _policyService = inject(PolicyService)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  constructor(
    private fb: FormBuilder,
    private _groupOfPoliceService: GroupOfPoliceService,
    private modalService: NgbModal,
  ) { 
    this.GroupForm = this.fb.group({
      _id: [null],
      name: ['', [Validators.required, Validators.minLength(5)]],
      campusId: ['', [Validators.required, Validators.minLength(2)]],
      policyId: ['', [Validators.required]],
      year: [null, [Validators.required]],
      enabled: [true, Validators.required]
    })
  }

  ngOnInit(): void {
    if(this.group != null){
      this.newGroup = false
      this.GroupForm.patchValue({
        _id: this.group._id,
        name: this.group.name,
        campusId: this.group.campusId,
        policyId: this.group.policyId,
        year: this.group.year,
        enabled: this.group.enabled
      })
    }
    this.getPolicies()
    this.getCampus()
  }

  submit(){
    if(this.GroupForm.valid){
      this.newGroup == true ? this._groupOfPoliceService.save(this.GroupForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        this.cerrarModal(res)}
      ) : 
      this._groupOfPoliceService.update(this.GroupForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        this.cerrarModal(res); this.newGroup = true
      })
      this.Toast.fire({
        text: 'Grupo actualizado',
        icon: 'success'
      })
    }
  }
   getPolicies() {
    if(this.GroupForm.value.year == null) this.GroupForm.patchValue({year: new Date().getFullYear()})
    this._policyService.getByYear(this.GroupForm.value.year).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listPolicies = res;
      this.cdr.markForCheck()
    })
  }


   getCampus() {
    this._campusService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((campus) => {
      this.listCampus = campus;
      this.cdr.markForCheck()
    });
  }

  cerrarModal(res: any){
    if(res) this.group_save.emit(true)
    this.modalService.dismissAll()
  }

  changeStatus(){
    this.GroupForm.value.enabled = !this.GroupForm.value.enabled
  }
}
